import getFieldsFromEnrolments from './TransformationHelpers/getFieldsFromEnrolments';
import getFieldsFromOffer from './TransformationHelpers/getFieldsFromOffer';
import getFieldsForSections from './TransformationHelpers/getFieldsForSections';

export default function transformCourseForLearningSpace(
  enrolments,
  offer,
  states,
  stateInteractions,
  contentDetails,
  preRequisitesData,
  offerContentSetting
) {
  const offerFields = getFieldsFromOffer(offer, states, preRequisitesData, offerContentSetting);
  const enrolmentFields = getFieldsFromEnrolments(enrolments);
  const sectionFields = getFieldsForSections(offer, contentDetails, states, stateInteractions);

  const response = {
    ...offerFields,
    ...enrolmentFields,
    ...sectionFields
  };
  return response;
}
